import React, { useEffect, useMemo, useState } from 'react';
import { sortBy, uniq } from 'lodash';

import Box from '@mui/material/Box';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';
import Button from '../shared/Button';

const FilterProceduresModal = (props) => {
  const {
    filter,
    open,
    onSubmit,
    onClose,
    procedures,
    countries,
  } = props;

  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedFlows, setSelectedFlows] = useState([]);

  const flowOptions = useMemo(() => {
    return sortBy(uniq((procedures || []).map((procedure) => procedure?.flow).filter(Boolean)));
  }, [procedures]);

  useEffect(() => {
    if (filter) {
      setSelectedCountries(filter.countries || []);
      setSelectedFlows(filter.flows || []);
    }
  }, [open, filter, procedures]);

  const onClear = () => {
    setSelectedCountries([]);
    setSelectedFlows([]);
  };

  const handleSubmit = () => {
    onSubmit({
      countries: selectedCountries,
      flows: selectedFlows,
    });
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Filter Procedures"
      subtitle="Apply filters to find specific procedures"
      submitText="Submit"
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' }, maxWidth: '560px' }}>
        <Box>
          <Autocomplete
            value={selectedCountries}
            onChange={setSelectedCountries}
            options={countries}
            label="Country"
            multiple
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <Autocomplete
            value={selectedFlows}
            onChange={setSelectedFlows}
            options={flowOptions}
            label="Flow"
            multiple
          />
        </Box>
        <Button
          sx={{ mt: 2 }}
          text="Clear Filters"
          icon={<FilterAltOffOutlinedIcon />}
          onClick={onClear}
          type='secondary'
        />
      </Box>
    </Drawer>
  );
};

export default FilterProceduresModal;
